import { debounce } from '../../common/Utils';
import {
  getCurrencySymbol,
  getMainStoreInstance,
  mainStoreName,
  widgets,
} from '../../common/Algolia';

const facet = 'price_f';
const dicoPriceKey = 'price';

// Constants (ids)
const rangeSliderId = 'ais-range-slider';
const rangeMinId = 'filterPriceId_fMin';
const rangeMaxId = 'filterPriceId_fMax';
// Constants (class)
const tooltipContainerMinClass = 'ais-range-slider--handle-lower';
const tooltipContainerMaxClass = 'ais-range-slider--handle-upper';
const tooltipClass = 'ais-range-slider--tooltip';

/* Store instance */
let occStore;
/* DOM elements use as starting points */
let $rangeSlider;
let dicoPrice;
/* Those waiting for templates rendering (render event) */
let $rangeMin;
let $rangeMax;

/* Range tooltip debouncer */
const delayedMaxUpdate = debounce(() => {
  $rangeMax[0].textContent = $(`.${tooltipContainerMaxClass} .${tooltipClass}`)[0].textContent;
}, 20);
const delayedMinUpdate = debounce(() => {
  $rangeMin[0].textContent = $(`.${tooltipContainerMinClass} .${tooltipClass}`)[0].textContent;
}, 20);

/* Setup formatted price clamps */
function setRangelabels() {
  $rangeMin[0].textContent = $(`.${tooltipContainerMinClass} .${tooltipClass}`)[0].textContent;
  $rangeMax[0].textContent = $(`.${tooltipContainerMaxClass} .${tooltipClass}`)[0].textContent;
}

/* Register events once after the rendering complete */
function rangeSliderEventSetup() {
  if (typeof occStore !== 'undefined') {
    $rangeSlider.on('algolia-tooltip-dragmin', delayedMinUpdate);
    $rangeSlider.on('algolia-tooltip-dragmax', delayedMaxUpdate);

    occStore.once('render', () => {
      /* Call this setup only on the first render (waiting templates rendering) */
      $rangeMin = $(`#${rangeMinId}`);
      $rangeMax = $(`#${rangeMaxId}`);
    });

    occStore.on('render', () => {
      setRangelabels();
    });
  } else {
    console.error('Missing Algolia store connection.');
  }
}

/* Searchbox wideget setup */
function rangeSliderInit() {
  /* Init elements */
  $rangeSlider = $(`#${rangeSliderId}`);

  if ($rangeSlider.length > 0) {
    /* Get Store instance */
    occStore = getMainStoreInstance();

    try {
      dicoPrice = OCMS.aisPanel.dicoKeys[dicoPriceKey];
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-PANEL =====', error);
    }

    occStore.addWidget(
      widgets.rangeSlider({
        attributeName: facet, // See Algolia index config
        container: $rangeSlider[0], // Expect a vanilla DOM object
        tooltips: {
          format: (num) => { // USE to smoothly refresh slider footer tooltips (Also done in render event)
            const $tooltipParent = $(`.ais-range-slider--handle.rheostat-handle[aria-valuenow=${num}]`);

            if ($tooltipParent.hasClass(tooltipContainerMinClass)) {
              $rangeSlider.trigger('algolia-tooltip-dragmin');
            } else if ($tooltipParent.hasClass(tooltipContainerMaxClass)) {
              $rangeSlider.trigger('algolia-tooltip-dragmax');
            }

            return num.toString();
          }
        },
        templates: {
          header: () => {
            const cSymbol = getCurrencySymbol(mainStoreName);

            return `<div class='m-internal-search-filter-container__title a-text-m a-text-m--bold'>${dicoPrice}</div>
                    <div class="m-internal-search-container-list__values">
                      <span id="${rangeMinId}" class="m-internal-search-container-list__value a-text a-text--semi-bold" role="presentation"></span>
                      <span id="${rangeMaxId}" class="m-internal-search-container-list__value a-text a-text--semi-bold" role="presentation"></span>
                      <span class="m-internal-search-container-list__value a-text a-text--semi-bold">${cSymbol}</span>
                    </div>`;
          },
        },
        step: 1,
        pips: false,
        precision: 0,
        collapsible: false,
      })
    );

    /* Setup widget events after the "render" competion */
    rangeSliderEventSetup();

    return true;
  }

  return false;
}

// Named exports
export default rangeSliderInit;



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-range-slider.js